import type { UpdateUserRequest, User } from "types/User.type";

import { api } from "utils/api";
export const getUser = () => api.get<User>("/user/current");

export const updateUser = (user: UpdateUserRequest) => api.put<User>("/user/current", { ...user });

export const getRegisteredUser = () => api.get<User>(`/register/me`);
